import { makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { RISK_COLORS } from '../utils/constants';

const useStyles = makeStyles((theme) => ({
  legend: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(4),
    marginTop: theme.spacing(3),
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(1),
    borderTop: '1px solid #E2E8F0',
    flex: '0 0 auto',
    background: 'linear-gradient(180deg, rgba(248, 250, 252, 0.8) 0%, rgba(255, 255, 255, 0.9) 100%)',
    borderRadius: '0 0 8px 8px',
    boxShadow: '0 -1px 3px rgba(0, 0, 0, 0.02)',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(0.75, 1.25),
    borderRadius: '20px',
    background: 'rgba(255, 255, 255, 0.7)',
    border: '1px solid rgba(226, 232, 240, 0.6)',
    transition: 'all 0.2s ease-in-out',
    cursor: 'default',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.9)',
      border: '1px solid rgba(226, 232, 240, 0.8)',
      transform: 'translateY(-1px)',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
    },
  },
  legendColor: {
    width: 14,
    height: 14,
    borderRadius: '50%',
    border: '2px solid rgba(255, 255, 255, 0.8)',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)',
    flex: '0 0 auto',
  },
  legendLabel: {
    fontSize: 13,
    color: '#374151',
    fontWeight: 600,
    letterSpacing: '0.01em',
    whiteSpace: 'nowrap',
  },
  legendDescription: {
    margin: '12px 0 4px 0',
    fontSize: '11px',
    color: '#6B7280',
    textAlign: 'center',
    fontWeight: 500,
    letterSpacing: '0.02em',
    padding: '0 16px',
    lineHeight: 1.4,
  },
}));

const ComparisonLegend = ({ populationHealth, classes }) => (
  <>
    <div className={classes.legendItem}>
      <div
        className={classes.legendColor}
        style={{ backgroundColor: '#3498db', opacity: 0.6 }}
      />
      <span className={classes.legendLabel}>
        {populationHealth?.baselineLight || 'Baseline (Light)'}
      </span>
    </div>
    <div className={classes.legendItem}>
      <div
        className={classes.legendColor}
        style={{ backgroundColor: '#3498db' }}
      />
      <span className={classes.legendLabel}>
        {populationHealth?.followupFullColor || 'Follow-up (Full Color)'}
      </span>
    </div>
    <div className={classes.legendDescription}>
      {populationHealth?.colorsIndicateRiskLevels ||
       'Colors indicate risk levels: Red (Critical), Orange (High), Blue (Monitor), Green (Help Requested)'}
    </div>
  </>
);

const SingleModeLegend = ({ populationHealth, classes }) => (
  <>
    <div className={classes.legendItem}>
      <div
        className={classes.legendColor}
        style={{ backgroundColor: RISK_COLORS.CRITICAL }}
      />
      <span className={classes.legendLabel}>
        {populationHealth?.critical || 'Critical'}
      </span>
    </div>
    <div className={classes.legendItem}>
      <div
        className={classes.legendColor}
        style={{ backgroundColor: RISK_COLORS.HIGH }}
      />
      <span className={classes.legendLabel}>
        {populationHealth?.high || 'High'}
      </span>
    </div>
    <div className={classes.legendItem}>
      <div
        className={classes.legendColor}
        style={{ backgroundColor: RISK_COLORS.MONITOR }}
      />
      <span className={classes.legendLabel}>
        {populationHealth?.monitor || 'Monitor'}
      </span>
    </div>
    <div className={classes.legendItem}>
      <div
        className={classes.legendColor}
        style={{ backgroundColor: RISK_COLORS.HELP_REQUESTED }}
      />
      <span className={classes.legendLabel}>
        {populationHealth?.helpRequested || 'Help Requested'}
      </span>
    </div>
  </>
);

const ChartLegend = ({ isComparisonMode }) => {
  const classes = useStyles();
  const { en: { populationHealth } } = useSelector((state) => state.i18n);

  return (
    <div className={classes.legend}>
      {isComparisonMode ? (
        <ComparisonLegend populationHealth={populationHealth} classes={classes} />
      ) : (
        <SingleModeLegend populationHealth={populationHealth} classes={classes} />
      )}
    </div>
  );
};

export default ChartLegend;
